import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

const MAXIMUM_TOASTS = 2;

@Injectable()
export class ToastrService {

  toastCounter = 0;
  className = 'ToastrService';

  constructor(private toasterService: MessageService) {
    this.toasterService.messageObserver.subscribe((msg) => {
      this.toastCounter++;
      if (this.toastCounter > MAXIMUM_TOASTS) {
        this.toastCounter = 0;
        this.toasterService.clear();
      }
    });
    this.toasterService.clearObserver.subscribe((mgs) => {
      this.toastCounter--;
      if (this.toastCounter < 0) {
        this.toastCounter = 0;
      }
    })
  }

  add(value) {
    this.toasterService.add(value);
  }

  addAll(value) {
    this.toasterService.addAll(value);
  }

  clear() {
    this.toasterService.clear();
  }
}
